import { render } from "./SkeletonBlock.vue?vue&type=template&id=22ad3d10&scoped=true"
import script from "./SkeletonBlock.vue?vue&type=script&lang=js"
export * from "./SkeletonBlock.vue?vue&type=script&lang=js"

import "./SkeletonBlock.vue?vue&type=style&index=0&id=22ad3d10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ad3d10"]])

export default __exports__